import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { Button, CalendarField, TextInputField } from "../../../helpers";

import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";

import Loading from "../../../common/Loading";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";


const UploadEInvoiceModal = (props) => {
    const {
        handleOnUpdateEInvoice,
        visibleSellerEInvoiceModal,
        setVisibleSellerEInvoiceModal
    } = props

    const [isLoading, setIsLoading] = useState(false)

    const [EInvoiceDetails, setEInvoiceDetails] = useState({})

    const dispatch = useDispatch()

    const fileUploadHandler = ({ files, options }, doc_name) => {
        let [file] = files;

        const fileReader = new FileReader();
        if(file.size > 5242880){
            options.clear()
            return dispatch(raiseToast({severity:'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000}))
        }
        fileReader.onload = (e) => {
            const blob = URL.createObjectURL(file); 
            file.objectURL = blob
            let docObj = {
                url: file.objectURL,
                documentName: doc_name,
                fileName: file.name,
                dataURI: e.target.result,
                inputName: options.props.name
            }
            
            setEInvoiceDetails(prevState => ({...prevState, "EInvoiceDocProof": docObj}))
        }
        fileReader.readAsDataURL(file)
        options.clear()
    }

    const removeInvoiceDoc = () => {
        setEInvoiceDetails(prevState => ({...prevState, "EInvoiceDocProof": null}))
    }

    const handleOnUpdateEInvoiceDetails = async () => {
        setIsLoading(true)
        handleOnUpdateEInvoice(EInvoiceDetails)
        setIsLoading(false)

    }

    const handleEInvoiceDetailsChange = (e) => {
        setEInvoiceDetails(prevState => ({...prevState, [e.target.name]: e.target.value}))
    }

    return (
        <Dialog header="E-Invoice Details" visible={visibleSellerEInvoiceModal} style={{ width: '55vw', height: '40vh' }} onHide={() => { setVisibleSellerEInvoiceModal(false); setEInvoiceDetails({}) }}>
            <div>
                <div className="grid">
                    <div className="col-3">
                        <TextInputField name="EInvoiceNumber" labelText="E-Invoice Number" value={EInvoiceDetails.EInvoiceNumber} onChange={e => handleEInvoiceDetailsChange(e)}/>
                    </div>
                    <div className="col-4">
                        <CalendarField name="EInvoiceDate" labelText="E-Invoice Date" value={EInvoiceDetails.EInvoiceDate} onChange={e => handleEInvoiceDetailsChange(e)}/>
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-4 lg:mb-0">
                        <label htmlFor="poDoc" className="text-xs mb-1">E-Invoice Doc: </label>
                        {
                            EInvoiceDetails.EInvoiceDocProof ?
                            <div className="flex flex-row">
                                {
                                    EInvoiceDetails.EInvoiceDocProof?.url && <a href={EInvoiceDetails.EInvoiceDocProof.url} target="_blank" style={{cursor: "pointer", color: 'black', fontWeight: 'bold'}}>View</a>
                                }
                                <div className="flex flex-column align-items-end">
                                    <Button className="decrement-btn-icon p-0" icon="pi pi-minus-circle" text size="small" onClick={() => removeInvoiceDoc()}/>
                                </div>
                            </div> 
                            :
                            <FileUpload className="upload-btn" mode="basic" name="EInvoiceDocProof" accept=".jpg,.jpeg,.png,.pdf,.html"  customUpload auto chooseLabel="Upload E-Invoice Doc" uploadHandler={files => fileUploadHandler(files, "SELLER_EINVOICE_DOCPROOF")}  />
                        }
                    </div>
                </div>
                <div className="flex justify-content-end mt-4">
                    <Button className="h-2rem p-2" label="Update" onClick={() => handleOnUpdateEInvoiceDetails()} />
                </div>
            </div>
            <Loading visible={isLoading}/>
        </Dialog>
    )
}

export default UploadEInvoiceModal